exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".case-lookup .date-picker-container{margin-right:20px}.case-lookup .date-picker-container .react-datepicker__input-container{height:32px!important}.case-lookup .region-selector-container{margin-bottom:15px;margin-top:0;display:block;float:none!important}.case-lookup .region-selector-container .region-selector .Select{max-width:764px}.case-lookup table{margin-top:10px}.case-lookup table th.case-title{width:120px}.case-lookup table td.party-name{word-break:break-all;word-wrap:break-word}.case-lookup .Select.is-open{position:relative;z-index:1000}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/less-loader!./src/pages/filings/CaseLookup/caseLookup.less
 ** module id = 1094
 ** module chunks = 0
 **/